import React, { Component } from 'react';
import { Form, Icon, Input, Button} from 'antd';
import FormItem from 'antd/lib/form/FormItem';
import esEs from './../../assets/i18n/es_ES.json';

class Forgot extends Component {

  constructor(props) {
    super(props);
    this.state = { email: '' }
  }

  handleReset = () => {
    this.setState({ email: '' });
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields( (err, values) => {
      if (!err) {
        this.handleReset();
      }
    })
  }

  handleInputChange = event => {
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div className="forgot-container">
        <h1>{esEs.RE_ESTABLISH_PASSWORD.TITLE}</h1>
        <p>
          {esEs.RE_ESTABLISH_PASSWORD.CONTENT}
        </p>
        <Form onSubmit={this.handleSubmit} layout="vertical">
          <FormItem>
            {getFieldDecorator('email', {
              initialValue: this.state.email,
              rules: [{required: true, message: `${esEs.RE_ESTABLISH_PASSWORD.INPUTS.VALIDATION_EMAIL}`}],
            })(
              <Input prefix={<Icon type="mail"/>} name="email" onChange={this.handleInputChange}  placeholder={esEs.RE_ESTABLISH_PASSWORD.INPUTS.EMAIL}/>
            )}
          </FormItem>
          <FormItem>
            <Button type="primary" htmlType="submit">{esEs.RE_ESTABLISH_PASSWORD.BUTTONS.SEND}</Button>
          </FormItem>
        </Form>
      </div>
    );
  };
}

const ForgotForm = Form.create({ name: 'form_forgot' })(Forgot);

export default ForgotForm;



// WEBPACK FOOTER //
// ./src/components/forgot/forgot.js